import { post } from "./utils";

export const dismissTask = async (taskId: string) => await post(`tasks/${taskId}/dismiss`, null);
